export default {
  user: {},
  admUser: {},
  cust: {},
  subdomain: {},
  userToken: '',
  customerToken: '',
  currentRoute: '',
  prevRoute: {},
  seller: {},
  isLogged: false
}



// WEBPACK FOOTER //
// ./src/app/pages/auth/vuex/state.js